import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { PageHeader } from '../components/PageHeader';
import { PageLayout } from '../components/PageLayout';
import { ContactForm } from '../components/ContactForm';
import { apiService } from '../services/api';
import type { Contact } from '../types';
import toast from 'react-hot-toast';

export function ContactFormPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isNew = !id || id === 'novo';

  const [loading, setLoading] = useState(!isNew);
  const [contact, setContact] = useState<Contact | undefined>();

  useEffect(() => {
    if (!isNew && id) {
      setLoading(true);
      apiService
        .getContact(id)
        .then(setContact)
        .catch(() => {
          toast.error('Contato não encontrado');
          navigate('/contatos');
        })
        .finally(() => setLoading(false));
    }
  }, [isNew, id, navigate]);

  const handleSuccess = () => {
    navigate('/contatos');
  };

  const handleCancel = () => {
    navigate('/contatos');
  };

  if (!isNew && loading) {
    return (
      <>
        <Header title="Contatos" subtitle="Carregando..." compactTopbar />
        <PageLayout>
          <div className="flex items-center justify-center py-16">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500" />
          </div>
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <Header
        title="Contatos"
        subtitle={isNew ? 'Novo contato' : 'Editar contato'}
        compactTopbar
      />
      <PageLayout>
        <PageHeader
          title={isNew ? 'Novo contato' : 'Editar contato'}
          breadcrumbs={[
            { label: 'Home', href: '/' },
            { label: 'Contatos', href: '/contatos' },
            { label: isNew ? 'Novo contato' : 'Editar contato' },
          ]}
        />
        <div className="space-y-8 w-full">
          <div className="card-padrao overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-wrap items-center justify-between gap-4">
              <h2 className="font-semibold text-gray-800 dark:text-white/90">
                {isNew ? 'Novo contato' : 'Editar contato'}
              </h2>
            </div>
            <div className="p-5">
              <ContactForm
                contact={contact}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
                variant="page"
              />
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
}
